module.exports = __webpack_public_path__ + "0af5a7be2fdec41bb43ea0caa7c0345e.pdf";